import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrificeQuickChange = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 50,
	viewBox: "0 0 10.0 50.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 50.0 L 0.0 15.0 L 5.0 0.0 L 10.0 15.0 L 10.0 50.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 5.0 0.0 L 5.0 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1,
		strokeDasharray: "2 2"
	})]
});
export default SvgOrificeQuickChange;
